export const ROLE_KEY = {
    ADMINISTRATOR: 'ADMIN',
    EMPLOYEE: 'EMPLOYEE'
}

export const HEADER_TYPE = {
    ROLE: 'role',
    EMAIL: 'emailAddress'
}